export enum ENumberInputUnitPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}
